import "../sass/Footer.scss";
import tabSocialLinks from "../data/socialMediaLinks.json"
import SocialIcon from "./SocialIcon";
import GetAppIcon from '@material-ui/icons/GetApp';
import IconButton from "@material-ui/core/IconButton";

export default function Footer({etatFooter}) {

    return (
        <div className="Footer">
            <div>
                {
                    tabSocialLinks.map(icon => <SocialIcon key={icon.name} url={icon.url} iconName={icon.name} />)
                }
            </div>
           
            <div>
            <a href={etatFooter.fields.fichierCv.fields.file.url} target="blank">
                <span>{etatFooter.fields.telechargezCv}</span>
                    <IconButton>
                        <GetAppIcon fontSize="large"></GetAppIcon>
                    </IconButton>
                </a>
            </div>


        </div>

    );
}